var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNairaSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 26V4.104C5.99986 3.63865 6.15429 3.18643 6.43904 2.81837C6.72378 2.45031 7.12272 2.18725 7.57319 2.07051C8.02366 1.95378 8.50015 1.98997 8.92781 2.17341C9.35548 2.35685 9.71011 2.67715 9.93599 3.084L22.064 24.916C22.2899 25.3228 22.6445 25.6431 23.0722 25.8266C23.4998 26.01 23.9763 26.0462 24.4268 25.9295C24.8773 25.8127 25.2762 25.5497 25.5609 25.1816C25.8457 24.8136 26.0001 24.3614 26 23.896V2M2 10H30M2 18H30",
    stroke: "#00665A",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaSymbol);
export default __webpack_public_path__ + "static/media/NairaSymbol.c8212383c6b7aba5fac3921f9abc85ce.svg";
export { ForwardRef as ReactComponent };